module.exports = __webpack_public_path__ + "static/media/image_code.b28b1eca.svg";